import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  
// login:{
//     overflow: "auto",
//     position: "relative",
//     //backgroundColor:"white",
 
//     height: "100vh",
//     "& ,&:before": {
//         content: "",
//         position: "fixed",
//         left: 0,
//         right: 0,
//         zIndex: -1,
//         display: "block",
        
        
    
//         backgroundImage: `url(${bulk})`,
//         backgroundPosition: '0% 0%', 
//         backgroundSize: '100% 100%', 
//         backgroundRepeat: 'no-repeat',
    
        
//         width: "100%",
//         height: "100%",
//         width: "100%",
//         /*Fullheight*/height: "100vh",
//         backgroundRepeat: "no-repeat",
       
//         objectFit: "fill",
        

// }

// },
btnBox:{
    display:"flex",
    justifyContent:"center"
},

logo:{
  
    maxWidth:"350px",
    height:"170px",
   marginRight:"auto",
   marginLeft:"auto",
    display:"flex",
    justifyContent:"center"
   
},
logoDiv:{
backgroundColor:"white",
borderRadius:30,

padding:10,


},





settingBox:{
display:"grid",
gridTemplateColumns:"auto auto",
justifyContent:"right",
columnGap:10,
padding:"0 10px"

},
center:{
    display:"flex",
    alignContent: "center",
    justifyContent:"center",
    
},
form: {
    display: "grid",

    padding:"40px 20px",
 
    gridTemplateColumns: "auto",
    columnGap: "20px",
    rowGap:"20px",
    justifyContent: "center",
    textAlign:"center",
    margin:"30px 10%",
    alignItems: "center",
    color:"secondry",
    backgroundColor:theme.palette.background.paper,
    borderRadius:30
  
  
},
formBox:{


    display:"flex",
    justifyContent:"center",

    margin:"140px auto",
    maxWidth:600,
    width:"80%"
},

filed:{
    maxWidth:400,

   
    "& .MuiInputBase-root": {
        color:"black",
        backgroundColor:"white"
       
       
      },
    '& label': {
        color: 'black',
      },
    //   '& .MuiInput-underline:after': {
    //     borderBottomColor: 'white',
    //     color:"white"
    //   },
    //   '& .MuiOutlinedInput-root': {
    //     '& fieldset': {
    //       borderColor: 'white',
    //       color: 'white',
    //       textColor:"white",
          
    //     },
    //     '&:hover fieldset': {
    //       borderColor: 'white',
    //       color:"white"
    //     },
    //     '&.Mui-focused fieldset': {
    //       borderColor: 'white',
    //       color:"white"
    //     },},
        

    width:350,

    [theme.breakpoints.between('xs', 'md')]: {
       width:240,
     
      },

},

btn:{
    width:"300px",
    marginTop:"30px",

    '&:hover': {
        backgroundColor:"blue",
        transition: "all 1s ease",
    }
}


}));

